const keyValueList = [
    { codeGroup  : "JOB_STATUS", code: "Y", codeName: "complete" },
    { codeGroup  : "JOB_STATUS", code: "N", codeName: "running" },
    { codeGroup  : "JOB_ERROR", code: "Y", codeName: "error" },
    { codeGroup  : "JOB_ERROR", code: "N", codeName: "success" },
    { codeGroup  : "IMPORT_OPTION", code: -1, codeName: "validation" },
    { codeGroup  : "IMPORT_OPTION", code: 0, codeName: "add" },
    { codeGroup  : "IMPORT_OPTION", code: 1, codeName: "update" },
    { codeGroup  : "IMPORT_OPTION", code: 2, codeName: "addAndUpdate" },
    { codeGroup  : "IMPORT_OPTION", code: 3, codeName: "truncate" },
    { codeGroup  : "IMPORT_OPTION", code: 4, codeName: "delete" },
    { codeGroup  : "SEPARATOR_OPTION", code: 0, codeName: "csv" },
    { codeGroup  : "SEPARATOR_OPTION", code: 1, codeName: "tsv" },
    { codeGroup  : "SEPARATOR_OPTION", code: 2, codeName: "json" }
]

/**
 * @param {String} codeGroup codeGroup
 *
 * "CLS_DOMAIN" : Classification Domain group
*/
const findByCodeGroupList = (codeGroup) => {
    const result = keyValueList.filter((list) => {
        return list.codeGroup === codeGroup;
    });

    return result;
}

/**
 * @param {keyValueList} list findByCodeGroupList
 * @param {String} findStr code or codeName
*/
const getKeyValue = (list, findStr) => {
    const findByCode = list.find((obj) => {
        return obj.code === findStr;
    });

    const findByCodeName = list.find((obj) => {
        return obj.codeName === findStr;
    });

    return !findByCode && !findByCodeName ? {code : "NONE", codeName : "NO MATCHED DATA"} : findByCode || findByCodeName;
}

const ListOfKeyValue = {
    findByCodeGroupList,
    getKeyValue
}

export default ListOfKeyValue;